import { FeatureId } from '@/core/feature-flags/enums';
import { isLimitedToBE } from '@/core/feature-flags/feature-flags.service';

/** Все функции доступны полностью; ссылки на внешние ресурсы не формируются. */
export function getFeatureDetails(featureId?: FeatureId) {
  if (!featureId) {
    return { limitedToBE: false };
  }

  return { limitedToBE: isLimitedToBE(featureId) };
}
